// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--26VSG","center":"gallery-module--center--1wnkc","pic":"gallery-module--pic--mqwpk"};